import React, { useState } from "react";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";

const StyledDetails = styled.details`
  border-radius: 8px;
  margin-bottom: 20px;

  summary {
    list-style: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between; /* 👈 SPACE BETWEEN */
      width: 100%; /* 👈 TAKE FULL WIDTH */
      gap: 10px;

      .icon {
        transition: transform 0.3s ease;
      }
    }
  }

  &[open] {
    summary .title .icon {
      transform: rotate(180deg);
    }

    summary {
      margin-bottom: 10px;
    }
  }
`;

const CustomDetails = ({
  title = "Notes",
  children,
  titleClassname = "",
  ...restProps
}) => {
  return (
    <StyledDetails {...restProps}>
      <summary className="collapse-header">
        <span className={"title " + titleClassname}>
          <span>{title}</span>
          <DownOutlined className="icon" />
        </span>
      </summary>
      <div className="collapse-content">{children}</div>
    </StyledDetails>
  );
};

export default CustomDetails;
